import { useState } from "react";
import "./Login.css"; // Reuse Login styles
import { supabase } from "../../Servicios/supabaseClient";
import titulo from '../../Img/titulo.png';
import Swal from 'sweetalert2';
import { ClipLoader } from 'react-spinners';
import { Link } from 'react-router-dom';

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);

    const handleReset = async (e) => {
        e.preventDefault();
        if (!email) {
            Swal.fire({
                icon: 'error',
                title: 'Campo vacío',
                text: 'Por favor, ingresa tu correo electrónico.',
                confirmButtonColor: '#d33'
            });
            return;
        }

        setLoading(true);
        try {
            const { error } = await supabase.auth.resetPasswordForEmail(email, {
                // Redirige a la página de actualización en tu app
                redirectTo: window.location.origin + "/update-password",
            });

            if (error) throw error;
            Swal.fire({
                icon: 'success',
                title: '¡Listo!',
                text: 'Revisa tu correo (incluso Spam) para cambiar la contraseña.',
                confirmButtonColor: '#3085d6'
            });
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: "Error: " + error.message,
                confirmButtonColor: '#d33'
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="loginPage">
            {loading && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9999
                }}>
                    <ClipLoader color="#ffffff" size={50} />
                </div>
            )}
            <div className="loginContainer">
                <img src={titulo} style={{ width: "100%" }} alt="QuantumNodo" />
                <p className="loginSubtitle" style={{ margin: "0.5rem" }}>Recuperar Contraseña</p>

                <form className="loginForm" onSubmit={handleReset}>
                    <div className="inputGroup">
                        <label htmlFor="email" className="inputLabel">Email</label>
                        <input
                            type="email"
                            id="email"
                            className="inputField"
                            placeholder="Ingresa tu email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>

                    <button type="submit" className="loginBtn">Enviar correo de recuperación</button>
                </form>
                <div className="loginFooter">
                    <p>¿Recordaste tu contraseña? <Link to="/login" className="loginLink">Inicia sesión</Link></p>
                </div>
            </div>
        </div>
    );
}
